import React, { useEffect, useContext, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';

import { CheckCircle as CheckCircleIcon } from '@mui/icons-material/';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

function ModalMysteryWinners() {
  const { t } = useTranslation();

  const {
    updateInfoModalMysteryWinners,
    infoModalMysteryWinners,
    updateShowModalMysteryWinners,
    updateFocusOnMainScreen,
  } = useContext(AppContext);

  const infoModalMysteryWinnersRef = useRef(infoModalMysteryWinners);

  useEffect(() => {
    infoModalMysteryWinnersRef.current = infoModalMysteryWinners;
  }, [infoModalMysteryWinners]);

  const handleConfirm = () => {
    updateInfoModalMysteryWinners(false);
    updateShowModalMysteryWinners(false);
    updateFocusOnMainScreen(true);
  };

  const renderTable = () => {
    const rows = infoModalMysteryWinnersRef.current;

    if (!Array.isArray(rows) || rows.length === 0) {
      return <Box p={2}>{t('sales.noData')}</Box>;
    }

    return (
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* This is the scroll container */}
        <TableContainer
          sx={{
            flex: 1,
            overflow: 'auto',
            overflowX: 'hidden',
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  {t('sales.date')}
                </TableCell>
                <TableCell align="center">
                  {t('sales.userID')}
                </TableCell>
                <TableCell align="center">
                  {t('sales.username')}
                </TableCell>
                <TableCell align="center">
                  {t('sales.firstname')}
                </TableCell>
                <TableCell align="center">
                  {t('sales.lastname')}
                </TableCell>
                <TableCell align="center">
                  {t('sales.bingoName')}
                </TableCell>
                <TableCell align="center">
                  {t('sales.winnerCard')}
                </TableCell>
                <TableCell align="center">
                  {t('sales.gameID')}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, idx) => (
                <TableRow
                  key={`${row.userID}-${row.gameID}-${row.date}-${idx}`}
                >
                  <TableCell align="center">
                    {row.date}
                  </TableCell>
                  <TableCell align="center">
                    {row.userID}
                  </TableCell>
                  <TableCell align="center">
                    {row.username}
                  </TableCell>
                  <TableCell align="center">
                    {row.firstname}
                  </TableCell>
                  <TableCell align="center">
                    {row.lastname}
                  </TableCell>
                  <TableCell align="center">
                    {row.bingoName}
                  </TableCell>
                  <TableCell align="center">
                    {row.winnerCard}
                  </TableCell>
                  <TableCell align="center">
                    {row.gameID}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  const hasWinners =
    Array.isArray(infoModalMysteryWinnersRef.current) &&
    infoModalMysteryWinnersRef.current.length > 0;

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          {hasWinners ? (
            <div
              className="react-confirm-alert-body"
              style={{ width: '1200px', height: '800px' }}
            >
              <Paper
                elevation={3}
                sx={{
                  backgroundColor: '#232a45',
                  padding: 2,
                  borderRadius: 2,
                  height: '550px',
                  overflow: 'hidden', // important: contain the table
                }}
              >
                {renderTable()}
              </Paper>

              <div
                className="react-confirm-alert-button-group"
                style={{ marginTop: '55px' }}
              >
                <button
                  className="btn-custom-yes"
                  onClick={handleConfirm}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                  {t('sales.confirm')}
                </button>
              </div>
            </div>
          ) : (
            <div
              className="react-confirm-alert-body"
              style={{ width: '1000px' }}
            >
              <h1>{t('sales.noMysteryWinnersTitle')}</h1>
              <p>{t('sales.noMysteryWinnersText')}</p>

              <div
                className="react-confirm-alert-button-group"
                style={{ marginTop: '55px' }}
              >
                <button
                  className="btn-custom-yes"
                  onClick={handleConfirm}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                  {t('sales.confirm')}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalMysteryWinners;
